import React, { useEffect, useState } from "react";
import { useApp } from "../contexts/AppContext";
import api from "../lib/api";

const DEFAULT_IMAGES = [
    { url: "https://images.unsplash.com/photo-1658724685009-0514a6ee5958?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxpbmRpYW4lMjBjdXN0b21lciUyMGRpZ2l0YWwlMjB0YWJsZXR8ZW58MHx8fHwxNzg1Mjk1NDUzfDA&ixlib=rb-4.1.0&q=85", caption: "Digital Services" },
    { url: "https://images.unsplash.com/photo-1616101001234-7320af4f1aa7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHw0fHxkb2N1bWVudCUyMGFwcHJvdmFsJTIwc3RhbXB8ZW58MHx8fHwxNzg1Mjk1NDUzfDA&ixlib=rb-4.1.0&q=85", caption: "Certified Documents" },
    { url: "https://images.pexels.com/photos/36631639/pexels-photo-36631639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", caption: "Our Center" },
    { url: "https://images.unsplash.com/photo-1736281957869-7f80909c3b2e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjd8MHwxfHNlYXJjaHwzfHxjb2xvcmZ1bCUyMGVtYnJvaWRlcnklMjBtYWNoaW5lfGVufDB8fHx8MTc4NTI5NTQ1M3ww&ixlib=rb-4.1.0&q=85", caption: "Embroidery Services" },
    { url: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?w=940&q=85&auto=format&fit=crop", caption: "Financial Services" },
    { url: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=940&q=85&auto=format&fit=crop", caption: "Government Assistance" },
];

const withHost = (url) => (url && url.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${url}` : url);

const Gallery = () => {
    const { t } = useApp();
    const [items, setItems] = useState([]);
    const [active, setActive] = useState(null);

    useEffect(() => {
        api.get("/gallery")
            .then(({ data }) => setItems(data.length ? data : DEFAULT_IMAGES))
            .catch(() => setItems(DEFAULT_IMAGES));
    }, []);

    return (
        <div data-testid="page-gallery" className="container-x section-pad">
            <div className="max-w-2xl">
                <div className="chip bg-[hsl(var(--royal))]/10 text-[hsl(var(--royal))] mb-4">{t.nav.gallery}</div>
                <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{t.gallery.title}</h1>
                <p className="mt-3 text-muted-foreground">{t.gallery.desc}</p>
            </div>

            <div className="mt-10 grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
                {items.map((img, i) => (
                    <button key={img.id || i} onClick={() => setActive({ ...img, url: withHost(img.url) })} data-testid={`gallery-item-${i}`}
                        className={`relative overflow-hidden rounded-3xl border border-border group focus:outline-none focus:ring-4 focus:ring-[hsl(var(--royal))]/30 ${i % 5 === 0 ? "col-span-2 md:col-span-2 row-span-2" : ""}`}>
                        <img src={withHost(img.url)} alt={img.caption || "Sri Matha Multiservices"} className="w-full h-full object-cover aspect-[4/3] group-hover:scale-105 transition-transform duration-500" />
                        {(img.caption || img.category) && (
                            <div className="absolute inset-x-0 bottom-0 p-4 bg-gradient-to-t from-black/70 via-black/20 to-transparent text-left text-white text-sm font-semibold">
                                {img.caption || img.category}
                            </div>
                        )}
                    </button>
                ))}
            </div>

            {active && (
                <div data-testid="gallery-lightbox" onClick={() => setActive(null)}
                    className="fixed inset-0 z-[60] bg-black/80 backdrop-blur-sm flex items-center justify-center p-4">
                    <div onClick={(e) => e.stopPropagation()} className="relative max-w-4xl w-full">
                        <button onClick={() => setActive(null)} className="absolute -top-12 right-0 text-white/80 hover:text-white text-sm font-semibold">Close ✕</button>
                        <img src={active.url} alt={active.caption} className="w-full max-h-[80vh] object-contain rounded-2xl" />
                        {active.caption && <div className="mt-4 text-center text-white font-medium">{active.caption}</div>}
                    </div>
                </div>
            )}
        </div>
    );
};

export default Gallery;
